import axios from '@/libs/api.request'
import { genURLParams } from '@/libs/urlparamhelper'

export const getAll = (params, urlParams) => {
  return axios.request({
    url: '/da/tracksintegrityanalysis/all' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const searchByName = (params, urlParams) => {
  return axios.request({
    url: '/da/tracksintegrityanalysis/searchbyname/' + params.name + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getPage = (params, urlParams) => {
  return axios.request({
    url: '/da/tracksintegrityanalysis/' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getDetail = (params, urlParams) => {
  return axios.request({
    url: '/da/tracksintegrityanalysis/' + params.id + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const deleteObj = (params, urlParams) => {
  return axios.request({
    url: '/da/tracksintegrityanalysis/' + params.id + '' + genURLParams(urlParams),
    method: 'DELETE',
    credentials: 'include',
    data: params
  })
}

export const getClientPage = (params, urlParams) => {
  return axios.request({
    url: '/da/tracksintegrityanalysis/getclientpage' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const exportExcel = (params, urlParams) => {
  return axios.request({
    url: '/da/tracksintegrityanalysis/exportexcel' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const attentionAnalysis = (params, urlParams) => {
  return axios.request({
    url: '/da/tracksintegrityanalysis/attentionanalysis/' + params.selectTime + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const deleteByAnalyzeDatetimeRange = (params, urlParams) => {
  return axios.request({
    url: '/da/tracksintegrityanalysis/deletebyanalyzedatetimerange/' + params.start + '/' + params.end + '' + genURLParams(urlParams),
    method: 'DELETE',
    credentials: 'include',
    data: params
  })
}
